/** @format */

export default {
	computed: {
		searchFormSlot() {
			return this.getSearchFormSlot();
		},
		searchFormData() {
			return this.getSearcFormData();
		},
	},
	methods: {
		handleSearch() {
			this.handleActionEvent({ code: 'search' }, 'toolbar');
		},
		getSearchFormSlot() {
			let slot = [];
			if (this.searchForm && this.searchForm.forms) {
				slot = this.searchForm.forms.filter((form) => {
					if (form.fieldType === 'slot') {
						return form;
					}
				});
			}
			return slot;
		},
		getSearcFormData(resetPage) {
			// 是否重置分页
			if (resetPage) {
				this.pagination.page = 1;
			}
			return this.$refs.searchForm.params;
		},
		/**
		 * 重置表单
		 * @returns
		 */
		resetSearch() {
			if (!this.$refs.searchForm) {
				return;
			}
			this.$refs.searchForm.resetSearchForm();
		},
	},
};
